import { LineItem } from './LineItem'

export class Order {

    constructor(
        public id: string,
        public lineItems: LineItem[],
        public currencyCode: string,
        public isPaid: boolean = false
    ) { }

    total(): number {
        return this.lineItems.reduce((acc, lineItem) => {
            return acc + (lineItem.unitAmount() * lineItem.quantity)
        }, 0)
    }
}
